// components/common/DigiBrigiLogo/DigiBrigiLogo.tsx
import styles from './DigiBrigiLogo.module.css';
import { ReactComponent as AlgapiaLogoDark } from '../../../pictures/logo/dark_2.svg';
import { ReactComponent as AlgapiaLogoLight } from '../../../pictures/logo/light_color_2.svg';
import { useTheme } from '../../../contexts/ThemeContext';

interface DigiBrigiLogoProps {
  /** Font size in px for the wordmark. */
  size?: number;
  onClick?: () => void;
  className?: string;
  /** Shows the tiny "powered by ALGAPIA" line under the wordmark. Default true. */
  poweredBy?: boolean;
}

/** The DigiBrigi text wordmark — "Digi" in brand orange, "Brigi" in ink. */
const DigiBrigiLogo = ({ size = 22, onClick, className = '', poweredBy = true }: DigiBrigiLogoProps) => {
  const { theme } = useTheme();
  const AlgapiaLogo = theme === 'dark' ? AlgapiaLogoDark : AlgapiaLogoLight;

  return (
    <span
      className={`${styles.container} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick() : undefined}
    >
      <span className={styles.logo} style={{ fontSize: size }}>
        <span className={styles.digi}>Digi</span>
        <span className={styles.brigi}>Brigi</span>
      </span>
      {poweredBy && (
        <span className={styles.poweredBy} style={{ fontSize: Math.max(7, Math.round(size * 0.34)) }}>
          powered by
          <AlgapiaLogo className={styles.poweredByLogo} style={{ height: Math.max(8, Math.round(size * 0.42)) }} />
        </span>
      )}
    </span>
  );
};

export default DigiBrigiLogo;
